import { ManageOpportunityModal } from "./Opportunities/ManageOpportunityButton"

export default function OrderTrackingModals({ shipModals, modalState }) {
  const { 
    manageOppOpportunity, 
    setManageOppOpportunity, 
    manageOppOpportunityId,
    setManageOppOpportunityId,
    onDataChange 
  } = modalState
  
  const onManageOppUpdate = (data) => {
    setManageOppOpportunity(data)
    onDataChange?.({ manageOppOpportunity })
  }

  const onClose = () => {
    setManageOppOpportunity(undefined)
    setManageOppOpportunityId(undefined)
  }

  return (<>
    {(manageOppOpportunity || manageOppOpportunityId) &&
      <ManageOpportunityModal 
        opportunity={manageOppOpportunity} 
        opportunityId={manageOppOpportunityId} 
        shipModals={shipModals}
        onOpportunityUpdate={onManageOppUpdate} 
        onClose={onClose} 
      />
    }
  </>)
}